import React, { useEffect } from "react";
import autosize from "autosize";

export interface TextAutoResizeProps {
	autoComplete: string | boolean;
	className: string;
	onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
	placeholder: string;
	value: string;
	disabled: boolean;
	onKeyDown: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void;
}

const TextAutoResize = ({
	autoComplete,
	className,
	onChange,
	placeholder,
	value,
	disabled,
	onKeyDown,
}: TextAutoResizeProps): JSX.Element => {
	const textAreaRef = React.useRef<HTMLTextAreaElement>(null);

	useEffect(() => {
		if (textAreaRef.current) {
			textAreaRef.current.focus();
			autosize(textAreaRef.current);

			if (!value) {
				// reset initial height
				textAreaRef.current.style.height = "16px";
				textAreaRef.current.style.overflow = "initial";
			}
		}
	}, [value]);

	return (
		<React.Fragment>
			<textarea
				autoComplete={autoComplete as string}
				className={className}
				ref={textAreaRef}
				placeholder={placeholder}
				rows={1}
				onChange={onChange}
				value={value}
				disabled={disabled}
				onKeyDown={onKeyDown}
			/>
		</React.Fragment>
	);
};

export default TextAutoResize;
